import { Component, OnDestroy, OnInit } from '@angular/core';
import { Sensor, excludedSensorTypes, IValue, ApplianceTypes } from 'src/app/models/sensor';
import { Router, ActivatedRoute } from '@angular/router';
import { Zone } from 'src/app/models/zone';
import { Appliance } from 'src/app/models/appliance';
import { DataService } from 'src/app/services/data.service';
import { SocketIoService } from 'src/app/services/socket-io.service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { ZoneService } from '../../../services/zone.service';


export interface Category {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-appliances',
  templateUrl: './appliances.component.html',
  styleUrls: ['./appliances.component.less']
})
export class AppliancesComponent implements OnInit, OnDestroy {
  zones: Zone[] | null = null;
  currentCompany: any = null
  currentCompanyId: string | null = null
  
  subscriptionComp1: Subscription;
  subscriptionComp2: Subscription;
  constructor(private dataService: DataService,
    private route: ActivatedRoute,
    private socketService: SocketIoService,
    private zoneService: ZoneService,) {

      this.subscriptionComp1 = this.dataService.sharedCompany$.subscribe(company => {
        this.currentCompany = company;
      })

      this.subscriptionComp2 = this.dataService.sharedCompanyId$.subscribe(companyId => {
        this.currentCompanyId = companyId;
      })
  }

  ngOnInit(): void {

  }

  

  ngOnDestroy() {
    this.subscriptionComp1.unsubscribe();
    this.subscriptionComp2.unsubscribe();
  }

  updateCurrentZone(zone: Zone) {
    this.dataService.updateZone(zone);
  }

}
